/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import ImageModal from '../ImageModal';

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  closeButton?: boolean;
  disabled?: boolean;
  maxWidth?: React.CSSProperties['maxWidth'];
}

function EnlargableImage({
  disabled,
  closeButton,
  maxWidth,
  ...imgProps
}: Props) {
  const [isEnlarged, setIsEnlarged] = React.useState(false);

  const onEnlarge = () => {
    setIsEnlarged(true);
  };

  return (
    <>
      <img
        {...imgProps}
        style={{
          cursor: disabled ? 'default' : 'pointer',
          ...imgProps.style,
        }}
        onClick={() => !disabled && onEnlarge()}
        alt={imgProps.alt}
      />
      <ImageModal
        isOpen={isEnlarged}
        onClose={() => setIsEnlarged(false)}
        src={imgProps.src}
        alt={imgProps.alt}
        closeButton={closeButton}
        maxWidth={maxWidth}
      />
    </>
  );
}

export default EnlargableImage;
